<template>
  <div>
    <AlertConfirmModal ref="alertConfirmModal" />
    <div>
      <AppHeader/>
      <div :style="{ '--sidebar-width': sideBarWidth }" style="display: flex; justify-content: space-between;">
        <AppSidebar 
          :sideBarWidth="sideBarWidth"
        />
        <div
          class="sidebar-resizer"
          :style="{ '--sidebar-width': sideBarWidth }"
          @mousedown="startResize"
        ></div>
        
        <div v-if="isResizing" class="resize-overlay"></div>

        <div :class="['body-offset', $store.state.isTriggerAppMenu ? 'closed': 'open', 'bg-istoreui']">
          <!-- <pre>{{ display }}</pre> -->
          <div v-if="$store.state.currentMenu && $store.state.currentMenu.type==='url'">
            <v-container fluid class="py-0 px-0" style="overflow: hidden; height: calc(100vh - 64px);">
              <AppFrame />
            </v-container>
          </div>
          <div v-else>
            <v-container fluid class="py-0 px-0" style="height: calc(100vh - 64px); width: calc(100vw - var(--sidebar-width))">
              <template v-if="$store.state.isValidUrl">
                <!-- <template v-if="$store.state.currentMenu"> -->
                  <router-view/>
                <!-- </template>
                <template v-else>
                  <div class="flex items-center justify-center h-full text-center">
                    <div>
                      Current Star Number<br>
                      License Key Expiry Date<br>
                      Tenant Name<br>
                      Subscription Plan<br>
                    </div>
                  </div>
                </template> -->
              </template>
              <template v-else>
                <Page404/>
              </template>
            </v-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { v-container } from '@coreui/vue'
import AppHeader from '@/components/AppHeader.vue'
import AppSidebar from '@/components/AppSidebar.vue'
import AppFrame from '@/components/AppFrame.vue'
import Page404 from '@/views/pages/Page404.vue'
import { useDisplay } from 'vuetify'

export default {
  name: 'DefaultLayout',
  components: {
    AppHeader,
    AppSidebar,
    // v-container,
    AppFrame,
    Page404
  },
  data (){
    return{
      sideBarWidth: '280px',
      tmpsideBarWidth: '280px',
      isResizing: false,
    }
  },
  created() {
    if(this.$store.state.isTriggerAppMenu){
      this.tmpsideBarWidth= this.sideBarWidth
      this.sideBarWidth = '0px'
    }
    else{
      this.sideBarWidth = this.tmpsideBarWidth
    }
  },
  setup(){
    const display = useDisplay()

    /*
      display.smAndDown = true -> using mobile phone
      display.md = true -> using tablet
      display.lgAndUp = true -> using Desktop
    */

    return {
      display
    }
  },
  methods: {
    appMenuTrigger(){
      this.$store.commit("triggerAppMenu")
      if(this.$store.state.isTriggerAppMenu){
        this.tmpsideBarWidth= this.sideBarWidth
        this.sideBarWidth = '0px'
      }
      else{
        this.sideBarWidth = this.tmpsideBarWidth
      }
    },
    goToDashboard() {
      if (this.$route.path !== '/dashboard') {
        this.$router.replace('/dashboard')
      }
      this.$store.commit('setCurrentMenu')
    },
    async showLogoutAlert() {
      const modalMessage = this.langKey.notifAutoLoggedOut
      const modalInstance = this.$refs.alertConfirmModal
      const showCancelButton = false
      const confirmed = await modalInstance.openModal(modalMessage, showCancelButton)
      if (confirmed) {
        // window.location.href = '/imanager'
        const port = window.location.port ? `:${window.location.port}` : ''
        window.location.href = `${window.location.protocol}//${window.location.hostname}${port}/imanager/#/login`
      }
    },
    startResize() {
      if(!this.$store.state.isTriggerAppMenu){
        this.isResizing = true
        document.addEventListener('mousemove', this.handleMouseMove)
        document.addEventListener('mouseup', this.stopResize)
      }
    },
    handleMouseMove(e) {
      if (this.isResizing && e.clientX <= 360) {
        this.sideBarWidth = Math.max(180, e.clientX)+"px"
      }
    },
    stopResize() {
      this.isResizing = false
      document.removeEventListener('mousemove', this.handleMouseMove)
      document.removeEventListener('mouseup', this.stopResize)
    },
  },
  watch: {
    // To allow us accessing another menu with valid URL when navigating from a menu with invalid URL
    '$store.state.currentMenu.url'() {
      this.$store.commit('setChosenUrlValidity', true)
    },
    '$store.state.isLogOutBypassed'(value) {
      if (value === true) {
        this.showLogoutAlert()
      }
    }
  },
}
</script>

<style scoped>
.body-offset {
  flex: 1;
  transition: margin-left 0.3s ease;
  /* margin-left: var(--sidebar-width, 0px); */
}

.body-offset.closed {
  margin-left: 0px;
}

.sidebar-resizer {
  width: 3px;
  cursor: col-resize;
  background-color: #FFFFFF;
  margin-left: var(--sidebar-width, 0px);
  text-align: center;
  height: calc(100vh - 64px);
  flex-shrink: 0; /* don't collapse */
  z-index: 10;
  border-right: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
}

.sidebar-resizer:hover,.sidebar-resizer:active{
  background-color: #586CDA;
}

.resize-overlay {
  position: fixed;
  top: 64px; /* height of AppHeader */
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  cursor: col-resize;
}
</style>
